module.exports = __webpack_public_path__ + "static/media/location.b9a4041f.png";